module.exports = __webpack_public_path__ + "img/no_favourites.cb074ea5.png";